import { newRelic } from '~/utils/newRelic/newRelic';

import { createDeviceEventsClient } from './deviceEventsClient.util';
import { initDeviceEvents } from './deviceEventsInit.util';

export const setupDeviceEventsClient = () => {
  try {
    initDeviceEvents(createDeviceEventsClient());
  } catch (error) {
    newRelic.log('[device-events] Error setting up DeviceEventsClient', {
      customAttributes: { error: error instanceof Error ? error : String(error) },
      level: 'ERROR',
    });
  }
};
